/**
 * Soft navigation for the mobile bottom tab bar.
 *
 * The tab bar (#amanaMobileNav) lives outside <main id="MainContent"> in
 * theme.liquid, so it is never touched by this script's DOM swap and never
 * unmounts between taps — that's what removes the reload flash. Only
 * #MainContent's innerHTML is replaced with the fetched page's #MainContent.
 *
 * Falls back to a normal browser navigation whenever anything is uncertain
 * (cross-origin link, modifier-click, fetch failure, Shopify theme editor),
 * so this is purely progressive enhancement on top of the plain <a href>
 * links already in mobile-nav-bar.liquid.
 */
(function () {
  function isDesignMode() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  function sameOrigin(url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function executeScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function setActiveNavItem(pathname) {
    document.querySelectorAll('.amana-mobile-nav__item[href]').forEach(function (item) {
      var itemPath = item.getAttribute('href').split('?')[0].split('#')[0];
      item.classList.toggle('amana-mobile-nav__item--active', itemPath === pathname);
    });
  }

  function runReInitHooks() {
    if (typeof window.initFavoriteIcons === 'function') window.initFavoriteIcons();
    if (typeof window.updateAllSwatchSliders === 'function') window.updateAllSwatchSliders();
    if (
      window.FavoritesPage &&
      typeof window.FavoritesPage.init === 'function' &&
      document.getElementById('favorites-list')
    ) {
      window.FavoritesPage.init();
    }
    document.dispatchEvent(new CustomEvent('amana:soft-navigation'));
  }

  function navigate(url, push) {
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Soft navigation fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.getElementById('MainContent');
        var main = document.getElementById('MainContent');
        if (!newMain || !main) throw new Error('Soft navigation: #MainContent missing');

        main.innerHTML = newMain.innerHTML;
        document.title = doc.title;

        if (push) {
          history.pushState({ amanaSoftNav: true }, '', url);
        }

        setActiveNavItem(new URL(url, window.location.href).pathname);
        executeScripts(main);
        runReInitHooks();
        window.scrollTo(0, 0);
      })
      .catch(function () {
        // Anything went wrong: fall back to a real navigation.
        window.location.href = url;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (isDesignMode()) return;

    var navBar = document.getElementById('amanaMobileNav');
    if (!navBar) return;

    navBar.addEventListener('click', function (e) {
      var link = e.target.closest('.amana-mobile-nav__item[href]');
      if (!link || e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var url = link.getAttribute('href');
      if (!url || !sameOrigin(url)) return;

      // Always intercept clicks on tab-bar items: falling through to the
      // real <a href> here (e.g. tapping the tab you're already on) is
      // exactly the full-reload flash this script exists to avoid.
      e.preventDefault();

      var targetPath = url.split('#')[0].split('?')[0];
      if (targetPath === window.location.pathname) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      navigate(url, true);
    });

    window.addEventListener('popstate', function () {
      navigate(window.location.href, false);
    });
  });
})();
